export default {
  appTitle: "Automatic Fault Detection in Power Transmission Lines (AFTL)",
  appName: "AFTL",
  logoAlt: "AFTL Logo",
  copyright:
    '© 2020 <a href="https://www.nri.ac.ir/" target="_blank" style="color: black;">NRI.AC.IR</a>, <a href="https://www.virakavir.com/" target="_blank" style="color: black;">VIRAKAVIR.COM</a>. All Rights Reserved.',
  loginToSystem: "Log in",
  login: "Login",
  userName: "Username",
  userNameExample: "Example: 09123456789",
  password: "Password",
  capsLockIsOn: "Note: The Caps Lock key is on.",
  forgotPassword: "Forgot password?",
  welcome: "Welcome",
  wrongUsernamePassword: "Username or password is incorrect.",
  version: "Version",
  dashboard: "Dashboard",
  message403: "Forbidden",
  message404: "Not Found",
  message500: "Internal Server Error",
  return: "Return",
  sendTAC: "Send Temporary Code",
  sendTACDescription:
    "By submitting this form, a temporary code will be sent to you via SMS, which on the next page, by entering it and the new password, your new password will replace your previous password.",
  send: "Send",
  iHavePassword: "I have a password.",
  iHaveTAC: "I have a temporary code.",
  TACSent: "Temporary code sent to you.",
  newPassword: "New Password",
  TAC: "Temporary Code",
  confirmNewPassword: "Confirm New Password",
  save: "Save",
  doNotHaveTAC: "I do not have a temporary code.",
  setNewPassword: "Set a new password.",
  newPasswordSaved: "Your new password has been saved.",
  changeTheme: "Change Theme",
  resizeMenu: "Resize Menu",
  profile: "Profile",
  activities: "Activities",
  signOut: "Sign Out",
  dashboardToolTip: "Summary of Statistics",
  employers: "Employers",
  employersToolTip: "Management of employers, contractors, lines and towers",
  users: "Users",
  usersToolTip: "User Management",
  activitiesToolTip: "Search User Aactivities",
  images: "Images",
  imagesToolTip: "Images Uploaded",
  searchImages: "Search Images",
  searchImagesToolTip: "Search Uploaded Images",
  reports: "Reports",
  reportsToolTip: "Manage Rreports",
  supportCenter: "Support Center",
  supportCenterToolTip: "Support Management Center",
  models: "Models",
  modelsToolTip: "Model Management",
  systemStatus: "System Status",
  systemStatusToolTip: "Resource Consumption and Status of Services",
  logs: "Logs",
  logsToolTip: "Server and System Logs",
  colleagues: "Colleagues",
  colleaguesToolTip: "Show Colleagues",
  contractors: "Contractors",
  contractorsToolTip: "Show Contractors",
  shootingGuide: "Shooting Guide",
  shootingGuideToolTip: "How to shoot with a drone?",
  uploadImages: "Upload Images",
  uploadImagesToolTip: "Upload Images",
  support: "Support",
  supportToolTip: "Support",
  about: "About",
  aboutToolTip: "About Company",
  changes: "Changes",
  changesToolTip: "History of System Changes",
  changesTitle: "History of Changes",
  logout: "Logout",
  logoutTitle: "Logout",
  lines: "Lines",
  towers: "Towers",
  searchActivities: "Search Activities",
  continueUpload: "Resume Uploading Images",
  uploadedImages: "Uploaded Images",
  modelErrors: "Model Errors",
  reportOnMap: "Report on Map",
  batchImageOperations: "Image Batch Operations",
  reportOperations: "Report Operations",
  requestSupport: "Request Support",
  help: "Help",
  showHelp: "Show Help",
  dateFrom: "From",
  dateTo: "To",
  updateStatistics: "Update Statistics",
  imagesWithWithoutErrors: "Number of Images With and Without Error",
  withError: "With Error",
  withoutError: "Without Error",
  numberOfErrorTypes: "Number of Errors Types",
  gotIt: "Ok",
  normal: "Normal",
  warning: "Warning",
  critical: "Critical",
  employersImages: "Number of Employers Images",
  employer: "Employer",
  number: "Number",
  errorsFrequency: "Frequency of Errors",
  error: "Error",
  management: "Management",
  system: "System",
  low: "Low",
  medium: "Medium",
  high: "High",
  dashboardHelp:
    'This page displays a summary of system statistics by default over the past week. To view the statistics in the desired time period, first select the time period and then select the "Update Statistics" button.',
  viraName: "Vira Kavir Co",
  viraIntro:
    "With an experienced and specialized staff (consisting of top university professors and industry-skilled engineers) in the field of capturing and processing remote sensing images (satellite images, UAVs, radar, etc.) is at the service of the great industry of our beloved country.",
  contactInformation: "Contact Information",
  address: "Address",
  viraAddress:
    "Unit 14, Niloufar Building, 1 Alley, Imam Khomeini St., Qarani Square, Kerman, Iran",
  programmer: "Website analysis, design and implementation",
  aliMHZ: "Ali Mohammad Hossein Zadeh",
  refresh: "Refresh",
  compactView: "Compact View",
  ticketOpen: "Open",
  ticketInProgress: "In Progress",
  ticketClosed: "Closed",
  view: "View",
  createNewRequest: "Create New Request",
  subject: "Subject",
  priority: "Priority",
  description: "Description",
  file: "File",
  ticketMaxFileSize: "Maximum file size is 1 MB.",
  create: "Create",
  new: "New",
  ticketsHelp:
    "If you encounter a problem while working with the system or have questions about different parts of the system, on this page you can send it to us by sending a ticket.",
  row: "Row",
  id: "ID",
  status: "Status",
  attachment: "Attachment",
  downloadAttachment: "Download Attachment",
  replies: "Replies",
  updateDate: "Updated at",
  operations: "Operations",
  createDate: "Created at",
  reply: "Reply",
  user: "User",
  replySaved: "New response created.",
  downloadStarted: "File download started.",
  fileNotExist: "File does not exist.",
  supportRequestSaved: "New support request created.",
  ticketHelp:
    "On this page you will see all the messages sent and received about the problem you have mentioned.",
  viewFileContent: "View File Content",
  downloadFile: "Download File",
  logsHelp:
    "This page is only available to super admin users.<br>All log files generated by the web server and system that contain useful information for troubleshooting can be viewed and downloaded on this list page.",
  server: "Server",
  name: "Name",
  fileSize: "File Size",
  fileContent: "Contents of the {0} file",
  services: "Services",
  osHelp:
    "<p>This page is only available to super admin users.<br>The following basic values are displayed to monitor server performance and are updated instantly:</p><ul><li>Percentage of CPU usage</li><li>Percentage of memory usage</li><li>Percentage of hard drive space used</li></ul><p>Also in the table of services, the names and status of all services required by the system are displayed. Notify support immediately if their status is one of the unknown values, stopped or out of reach.</p>",
  used: "Used",
  available: "Available",
  hardSpace: "Hard Disk Space",
  percentage: "Percentage",
  usagePercentage: "Usage Percentage",
  oneMinuteInterval: "One Minute Interval",
  memoryUsage: "Memory Usage",
  cpuUsage: "CPU Usage",
  activateAllModels: "Activate All Models",
  disableAllModels: "Disable All Models",
  viewErrors: "View Errors",
  edit: "Edit",
  delete: "Delete",
  createNewModel: "Create New Model",
  folder: "Folder",
  modelCompletePath: "The Complete Path of the Model Folder",
  change: "Change",
  no: "No",
  yes: "Yes",
  sureToActivateModels: "Are you sure you want to activate all models?",
  sureToDisableModels: "Are you sure you want to disable all models?",
  modelsHelp:
    "<p>This page is only available to super admin users.<br>Models and their errors are managed on this page and its sub-pages.</p><p>When creating a new model, the status of that model is disabled by default. If model mode is disabled, uploaded images will not be sent to that model for error detection. It is better to edit and activate the model after defining it and model errors.</p>",
  errors: "Errors",
  active: "Active",
  disabled: "Disabled",
  newModelCreated: "The new model was created.",
  editModel: "Edit the {0} model",
  modelEdited: "The selected model was edited.",
  cannotDeleteModel: "Can not be deleted. Delete the error (s) first.",
  sureToDeleteModel: "Are you sure you want to delete the {0} model?",
  selectAModel: "Choose a model.",
  modelDeleted: "The selected model was removed.",
  allModelsActivated: "All models were activated.",
  allModelsDisabled: "All models were disabled.",
  createNewError: "Create a new error for {0}",
  code: "Code",
  type: "Type",
  thisField: "This field",
  newErrorCreated: "The new error was created.",
  editError: "Edit the {0} error",
  errorEdited: "The selected error was edited.",
  sureToDeleteError: "Are you sure you want to delete the {0} error?",
  selectAnError: "Choose an error.",
  errorDeleted: "The selected error was removed.",
  errorsHelp:
    "On this page you can change the error specifications of the selected model. Note that the error code must be exactly the value that the model returns and also can not be duplicated.",
  adminTicketsHelp:
    '<p>This page is only available to super admin users.</p><p>On this page, a list of all requests of system users can be seen. The super admin can delete the request at his discretion. Request status changes to "Open" after each reply.</p>',
  sureToDeleteTicket: "Are you sure you want to delete the {0} ticket?",
  selectATicket: "Choose a ticket.",
  ticketDeleted: "The selected ticket was removed.",
  adminTicketHelp:
    '<p>This page is only available to the super admin user.</p><p>When a request is viewed, its status will change to "In Progress" and if the request is answered, the status will change to "Closed".</p>',
  chooseAnOption: "Choose an option.",
  line: "Line",
  errorType: "Error Type",
  errorName: "Error Name",
  search: "Search",
  searchResult: "Search Result",
  searchResultOnMap: "Show Search Result on Map",
  searchImagesHelp:
    "On this page, you can find images with the desired specifications from the uploaded images.",
  language: "Language",
  profileHelp:
    '<p>On this page you can change your username and password.<br>You only need to fill in all the password options if you want to change your password, otherwise just change your name and click the "Change" button.</p>',
  profileSaved:
    "Profile saved. If you have changed the language please log out and log in again.",
  userActivitiesHelp:
    "All your activities are registered in the system. On this page you can see the list of your activities.",
  activity: "Activity",
  userType: "User Type",
  namePlaceHolder: "Enter the full name or part of it.",
  userNamePlaceHolder: "Enter the full or partial username.",
  contractor: "Contractor",
  createNewUser: "Create a New User",
  privileges: "Privileges",
  changeImageBatchStatus: "Change Status of Image Batch",
  deleteError: "Delete Error",
  userStatus: "User Status",
  usersHelp:
    '<p>This page is only available to administrators.<br>Administrator can create, edit or delete a user. If a user has uploaded a batch of images, that user cannot be deleted as long as that batch is available.</p><p>If the user type is selected from one of the employer types, the employer field and its selection will be required. Also, if the user type is selected from one of the contractor types, it will be necessary to select both the employer and the contractor fields.</p><p>When editing a user profile, enter it only if you need to change the password, otherwise you do not need to enter it. Also, if a user cannot be deleted and their access to the system must be blocked, you can disable that user. Disabled user can not log in.</p><p>In addition to the type of user that each has its own restrictions and permissions, permissions are defined for users that to enable them, you must select the "permissions" section when creating / editing the user.</p>',
  superAdmin: "Super Admin",
  admin: "Admin",
  employerExpert: "Employer-Expert",
  employerManager: "Employer-Manager",
  contractorPilot: "Contractor-Pilot",
  contractorExpert: "Contractor-Expert",
  contractorManager: "Contractor-Manager",
  newUserCreated: "The new user was created.",
  editUser: "Edit user {0}",
  userEdited: "The selected user has been edited.",
  sureToDeleteUser: "Are you sure you want to delete the user {0}?",
  selectAUser: "Select a user.",
  userDeleted: "Selected user deleted.",
  operationDescription: "Operation Description",
  date: "Date",
  downloadExcel: "Download search result in Excel format",
  searchActivitiesHelp:
    "<p>This page is only available to super admin users.<br>On this page, the administrator can search the activities of all users by selecting one or more options.</p><ul><li>User</li><li>Operation: Type of activity performed</li><li>IP: The full or part of the user's IP address</li><li>Description: Keyword</li><li>Date: Time period</li></ul><p>Search results could be downloaded as excel file.</p>",
  changePassword: "Change Password",
  resetPassword: "Reset Passwrod",
  insert: "Insert",
  upload: "Upload",
  download: "Download",
  ip: "IP",
  atLeastOneOption: "Select at least one option.",
  pageNumber: "Page Number",
  highQuality: "High Quality",
  reportInPDF: "Report in PDF format",
  reportInExcel: "Download the report in Excel format",
  reportInKMZ: "Download the report in KMZ format",
  viewOperations: "View Operations",
  changeStatus: "Change Status",
  dataEntry: "Data entry",
  waitingToCreate: "Waiting to start creating",
  creatingExcel: "Creating an Excel file",
  creatingPDF: "Creating PDF file",
  creatingKMZ: "Creating KMZ file",
  finished: "Finished",
  changeStatusToStart: "Change the status to waiting to start creating",
  adminReportsHelp:
    '<p>This page displays all the reports created by users in the system.<br>The created report, in addition to being displayed on the map, is made in downloadable formats pdf, excel and kmz, which can be downloaded in Google Earth.</p><p>For each tower, a separate pdf file is created for that tower, which by selecting "Report in pdf format", the generated files corresponding to each tower are displayed and can be downloaded.</p><p>If for any reason it is necessary to re-generate the report files, the report will be queued by selecting the "Hourglass" button and then selecting "Change to Waiting Status".</p>',
  title: "Title",
  specifications: "Specifications",
  sureToDeleteReport: "Are you sure you want to delete the {0} report?",
  selectAReport: "Select a report.",
  reportDeleted: "Selected report deleted.",
  reportPDFFiles: "{0}'s PDF files",
  changeReportStatus: "Change the status of the report {0}",
  reportStatusChanged: "The status of the selected report was changed.",
  adminReportLogsHelp:
    "All operations on a report are saved and displayed on this page by everyone who has access to that report.",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  fullscreen: "Fullscreen",
  summaryErrors: "Summary of Errors",
  adminReportOnMapHelp:
    "This page shows the selected report line towers along with the number of errors on the map. Selecting a tower displays a list of errors and related images.",
  map: "Map",
  receivingInformation: "Receiving Information",
  reportOfCode: "Report of Tower {0} Code {1}",
  searchFolderName: "Search folder name",
  update: "Update",
  towerView: "Tower View",
  towerType: "Tower Type",
  imagesWithError: "Images with error",
  imagesWithoutError: "Images without error",
  selectAFolder: "Select a Folder",
  errorsList: "Errors List",
  fromExcelFile: "From Excel file",
  selectExcelFile: "Select an Excel file.",
  changeTowerType: "Change Tower Type",
  selectTowerType: "Please select the type of towers.",
  changeTowerView: "Change Tower View",
  selectJPGFile: "Select a JPG file.",
  adminImagesHelp:
    "<p>On this page you can see the uploaded images of a category.<br>Images are saved based on their folder structure. In a tree structure, by selecting each folder, its internal folders are displayed. Also, by selecting the primary folder or the tower, the images of the tower view and the type of tower are displayed. To find a specific folder, just type its name (case sensitive) in the search box. By selecting the folder where the images are located, the images of that folder are displayed on the left.</p><p>Click on the image to view it in original size. In the window that opens on the right, they are displayed in the table of detected errors, and if you have the necessary access, you can delete the incorrect error (s). On the left, the image is displayed in its original size, which you can zoom in / out in the following ways:</p><ul><li>Double-click: By double-clicking (double-clicking), the image will be magnified at the desired point, and by doing this again, the image will return to its original state.</li><li>Mouse wheel: By rotating the mouse wheel up and down, respectively, where the mouse pointer is on and off, zoom in and out are performed.</li></ul><p>After zooming in, you can see all parts of the image by dragging and dropping the image.</p>",
  coordinates: "Coordinates",
  showImageFullsize: "Display image {0} in full size",
  errorDeletedQueue:
    "The selected error was removed and the image was queued for tag updates.",
  towerTypeEdited: "The selected tower type was edited.",
  fileUploaded: "File uploaded.",
  fileUploadedErrorsCreated: "Upload file and errors were created.",
  adminBatchLogsHelp:
    "All operations that are stored on a batch of images by all accessible people are displayed on this page.",
  deleteAllErrors: "Delete All Errors",
  showErrors: "Show Errors",
  hideErrors: "Hide Errors",
  viewImages: "View Images",
  loading: "Loading",
  captureDate: "Date of Shooting",
  files: "Number of Files",
  of: "of",
  sureToDeleteBatch: "Are you sure you want to delete batch {0}?",
  selectABatch: "Select a Batch.",
  batchDeleted: "Selected batch deleted.",
  deleteAllBatchErrors: "Are you sure you want to delete all batch {0} errors?",
  batchErrorsDeleted: "Selected batch errors were deleted.",
  changeBatchStatus: "Change the status of the code {0}",
  batchStatusChangeSaved: "Change the status of the selected batch saved.",
  errorsWillDispalyed: "Errors will be displayed.",
  errorsWillHidden: "Errors will be hidden.",
  uploading: "Uploading",
  uploadingFinished: "Uploading finished",
  waitingToStartDiagnosis: "Waiting for the diagnosis to start",
  diagnosing: "Diagnosing",
  diagnosingFinished: "Diagnosing Finished",
  changeStatusToDiagnose: "Change the status to waiting to start diagnosing",
  viewLines: "View Lines",
  viewUsers: "View Users",
  viewContractors: "View Contractors",
  createNewEmployer: "Create New Contractor",
  logo: "Logo",
  logoPlaceHolder: "jpg, jpeg, png, bmp files with a maximum size of 500 KB",
  employersHelp:
    "<p>This page is only available to admin users.<br>The management of employers, contractors, lines and towers is done on this page and its sub-pages.</p><p>When creating a client, selecting the logo is mandatory, but in editing, select the logo only if you intend to replace the original logo.</p><p>The selected file for the logo must be a maximum of 500 KB and one of the following:<br>jpg, jpeg, bmp, png</p>",
  newEmployerCreated: "The new employer was created",
  editEmployer: "Edit employer {0}",
  employerEdited: "The selected employer was edited.",
  cannotDeleteEmployer:
    "Can not be deleted. First delete the user / contractor / line (s).",
  sureToDeleteEmployer: "Are you sure you want to delete employer {0}?",
  selectAnEmployer: "Select an Employer.",
  employerDeleted: "Selected employer deleted.",
  showUsers: "{0}' users",
  createNewContractorFor: "Create a new contractor for {0}",
  contractExpiration: "Contract Expiration",
  adminContractorsHelp:
    "<p>On this page you can change the specifications of the selected employer contractors. Also, to view a contractor's users, select the \"View Users\" button in front of the desired contractor.</p> <p>Please note that a contractor's users will not be able to log in after the contract expiration date.</p>",
  newContractorCreated: "A new contractor was created.",
  editContractor: "Edit contractor {0}",
  contractorEdited: "The selected contractor was edited.",
  cannotDeleteContractor: "Can not be deleted. Delete the user (s) first.",
  sureToDeleteContractor: "Are you sure you want to delete contractor {0}?",
  selectAContractor: "Select a contractor.",
  contractorDeleted: "Selected contractor deleted.",
  emploerContractorsHelp:
    'On this page you can see the details of all the contractors of your subset. Also, to display the profile of a particular contractor, you can view the list of users of each contractor by selecting the "View Users" button in front of each contractor.',
  importFromExcel: "Import data from Excel file",
  viewTowers: "View Towers",
  downloadLineTowersKMZ: "Download line and towers in KMZ format",
  viewTowersOnMap: "View Towers on Map",
  createNewLineFor: "Create a new line for {0}",
  origin: "Origin",
  destination: "Destination",
  singleCircuitLength: "Single circuit length",
  single: "Single",
  dualCircuitLength: "Dual circuit length",
  dual: "Dual",
  fourCircuitLength: "Four circuit length",
  four: "Four",
  sixCircuitLength: "Six circuit length",
  six: "Six",
  eightCircuitLength: "Eight circuit length",
  eight: "Eight",
  voltageLevel: "Voltage Level",
  history: "History",
  selectADate: "Select a date",
  importEmployerLinesExcel: "Import employer {0} lines from Excel file",
  sampleFile: "Sample File",
  linesHelp:
    '<p>On this page you can change the details of the lines belonging to the selected employer. Also, to manage the selected line towers, select the "View Towers" button in front of the desired line. To view all the towers of the desired line on the map, select the "View towers on the map" button in front of the desired line.</p><p>The color of the lines between the towers is determined by the value of the line voltage level:</p><ul><li>Blue: Less than 63</li><li>Green: Between 63 and 132</li><li>Red: Between 132 and 230</li><li>Purple: more than 230</li></ul><p>If you have line information (s), you can import it by converting it to an Excel file. The structure of the submitted Excel file should be the same as the sample file. Select the "Sample File" button to download the sample Excel file. There is also no need for the first row as column names and this row should be removed.</p>',
  circuitLength: "Circuit Length",
  batches: "Batches",
  newLineCreated: "A new line was created.",
  editLine: "Edit line {0}",
  lineEdited: "The selected line was edited.",
  cannotDeleteLine:
    "Can not be deleted. First remove the tower / category (s).",
  sureToDeleteLine: "Are you sure you want to delete line {0}?",
  selectALine: "Select a line.",
  lineDeleted: "Selected line deleted.",
  showLineTowers: "Show the towers of line {0}",
  fileUploadedLinesCreated: "The file was uploaded and the lines were created.",
  createNewTowerFor: "Create a new tower for {0}",
  latEnFa: "Latitude",
  lonEnFa: "Longitude",
  importLineTowersExcel: "Import line {0} towers from Excel file",
  towersHelp:
    '<p>On this page you can change the profile of the selected line towers.<br>The code value of each tower is very important because when uploading images, the tower folder name must be the same as the tower code you enter here.</p><p>Note that when entering information, be careful about the correct latitude and longitude values. To determine these values, you can type the desired numbers or click on the map in the appropriate place.</p><p>If you have the information of the tower (s), you can convert this information into an Excel file by importing it. The structure of the submitted Excel file should be the same as the sample file. Select the "Sample File" button to download the sample Excel file. There is also no need for the first row as column names and this row should be removed.</p><p>If towers are not created, towers will be created by uploading a batch of images for a line. Also, if latitude and longitude are not recorded for them, uploading the first image that contains this information will update the latitude and longitude of the tower.</p>',
  newTowerCreated: "A new tower was created.",
  editTower: "Edit tower {0}",
  towerEdited: "The selected tower was edited.",
  sureToDeleteTower: "Are you sure you want to delete tower {0}?",
  selectATower: "Select a tower.",
  towerDeleted: "Selected tower deleted.",
  fileUploadedTowersCreated:
    "The file was uploaded and the towers were created.",
  colleaguesHelp:
    "On this page, you will see the details of all your colleagues.",
  sendNewImages: "Send New Images",
  uploadHelp:
    '<p>To upload or upload images, first select the line to which the images belong, then enter the date on which the image was taken. Then select the photos folder and finally select the type of towers from the displayed images.</p><p>Inside the folder you select there should be a folder for each tower with the name of the tower whose code it is. Inside the folder of each tower, for different parts of the tower, there should be a folder with the specified names (like the names in the tower type image) and at the end there should be images in that folder. Also, if there is a jpg file in the tower folder, it will be selected as the tower image. Note that this image will not be sent at diagnosis.</p><p>After selecting the submit button, the images will be sent one by one and a progress bar will be displayed on which two numbers will be displayed. The first number is the percentage of total images sent and the second number is the percentage of progress of sending the current image. Each image that is sent will have its final submission name and status added in the table below. After sending all the pictures, if you have to send another batch of pictures, just select the "Send New Images" button.</p>',
  successful: "Successful",
  sent: "Sent",
  uploadCompleted: "Upload completed.",
  incorrectFolderStructure: "The folder structure is incorrect.",
  folderSelected: 'Folder "{0}" is selected with {1} files.',
  continueUploadingImages: "Continue uploading images",
  adminUploadsHelp:
    '<p>This page displays all batches of images uploaded by users to the system. In addition to displaying images, categories can be deleted if necessary.</p><p>If an error is detected for a batch of images, to delete those images, all errors must first be deleted in order to delete the batch of images. Note that deleting practical images is irreversible.</p><p>If you need to resubmit the uploaded image category, you can do so by selecting Hourglass and then selecting the "Change status to Pending Detection" button. Duplicate errors will not be recorded.</p>',
  uploadsHelp:
    '<p>This page displays all the batches of images uploaded by you or your colleagues in the system.</p><p>If for any reason the upload of images does not end or the upload of one or more files is encountered, on this page in front of the image category, the button "Continue uploading images" is displayed, by selecting which you can resume uploading images.</p><p>After uploading, the category status changes to "Finish uploading" and the images will not be sent for detection until the user changes the category status to "Waiting for detection to start". Also, if you need to resubmit the uploaded images to the detection, you will do so by selecting the hourglass and then selecting the "Change status to Waiting for detection" button. Duplicate errors will not be recorded.</p>',
  imagesHelp:
    '<p>On this page you can see the uploaded images of a batch.<br>Images are saved based on their folder structure. In a tree structure, by selecting each folder, its internal folders are displayed. To find a specific folder, just type its name in the search box. By selecting the folder where the images are located, the images of that folder are displayed on the left.</p><p>Click on the image to view it in original size. In the window that opens on the right, a table of detected errors is displayed, and if you have the necessary access, you can delete the incorrect error (s). On the left, the image is displayed in its original size, which you can zoom in / out in the following ways:</p><ul><li>Double-click: By double-clicking (double-clicking), the image will be magnified at the desired point, and by doing this again, the image will return to its original state.</li><li>Mouse wheel: By rotating the mouse wheel up and down, respectively, where the mouse pointer is on and off, zoom in and out are performed.</li></ul><p>After zooming in, you can see all parts of the image by dragging and dropping the image.</p><p>In the tree structure, by selecting the primary folder or the tower, the view of the tower and the type of tower are displayed. If they do not exist or need to be changed, you can select a new image for the upload tower or another type for the tower by selecting the "Update" button.</p>',
  batchLogsHelp:
    "All operations that are stored on a batch of images by all accessible people are displayed on this page.",
  createNewReport: "Create New Report",
  batchOfImages: "Batch of Images",
  selectBatchOfImages: "Select a batch of images",
  firstPageText: "First Page Text",
  reportsHelp:
    '<p>This page displays all the reports created by you and your colleagues in the system. The created report, in addition to being displayed on the map, is also made in downloadable formats pdf, excel and kmz, which can be downloaded in Google Earth.</p><p>For each tower, a separate pdf file is created for that tower, which by selecting "Report in pdf format", the generated files corresponding to each tower are displayed and can be downloaded.</p><p>When creating / editing a report, in addition to selecting the category of images, the title and text of the front page, you can specify whether to use high quality images in the production of report files or low quality images. You can also check whether the page number is printed or not in the pdf file production report.</p><p>After creating / editing the status report, it will be converted to "Data Entry" mode, and the report files will not be created until the user changes its status to "Waiting to start building".</p>',
  newReportCreated: "A new report was created.",
  editReport: "Edit report {0}",
  reportEdited: "The selected report was edited.",
  reportLogsHelp:
    "All operations on a report are saved and displayed by everyone who has access to it.",
  reportOnMapHelp:
    "This page shows the selected report line towers along with the number of errors on the map. Selecting a tower displays a list of errors and related images.",
  continueUploadHelp:
    'You are on this page because the file upload operation has not been completed for any reason. To continue uploading, just select the image folder you selected in the "Send Images" section. Images that have already been uploaded will not be sent back to the server.',
  securityCode: "Security Code",
  newSecurityCode: "New Security Code",
  updateAvailable: "An update is available",
  validations: {
    required: "{0} is required.",
    len: "The length of the {0} is {1} characters.",
    min: "The minimum length of the {0} is {1} characters.",
    max: "The maximum length of the {0} is {1} characters.",
    maxFileSize: "File size {0} must be less than {1} MB.",
    sameValue: "The value of {0} and {1} must be the same."
  },
  badge: "Badge",
  close: "Close",
  dataIterator: {
    noResultsText: "No matching records found.",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    nextMonthAriaLabel: "Next month",
    nextYearAriaLabel: "Next year",
    prevMonthAriaLabel: "Previous month",
    prevYearAriaLabel: "Previous year"
  },
  noDataText: "No data available.",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM"
  },
  pagination: {
    ariaLabel: {
      wrapper: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Goto Page {0}",
      currentPage: "Current Page, Page {0}"
    }
  },
  rating: {
    ariaLabel: {
      icon: "Rating {0} of {1}"
    }
  }
};
//# sourceMappingURL=en.js.map
